/* eslint-disable id-blacklist */

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

import type * as Types from './operations';

const defaultOptions = {};
export const CommonSimpleGameFragmentDoc = gql`
  fragment CommonSimpleGame on CashGame {
    id
    name
    gameType
    tableType
    blindStructure {
      smallBlind
      bigBlind
    }
    minBuyIn
    maxBuyIn
    tableSize
    currency
    bettingLimit
    currency
    cashGameProperties
    brands
    sites
    startTime
  }
`;
export const CashGamesGroupedUpdateDocument = gql`
  subscription cashGamesGroupedUpdate($include: Filter, $exclude: Filter) {
    cashGamesGrouped(include: $include, exclude: $exclude) {
      ...CommonSimpleGame
    }
  }
  ${CommonSimpleGameFragmentDoc}
`;

/**
 * __useCashGamesGroupedUpdateSubscription__
 *
 * To run a query within a React component, call `useCashGamesGroupedUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCashGamesGroupedUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCashGamesGroupedUpdateSubscription({
 *   variables: {
 *      include: // value for 'include'
 *      exclude: // value for 'exclude'
 *   },
 * });
 */
export function useCashGamesGroupedUpdateSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    Types.CashGamesGroupedUpdateSubscription,
    Types.CashGamesGroupedUpdateSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    Types.CashGamesGroupedUpdateSubscription,
    Types.CashGamesGroupedUpdateSubscriptionVariables
  >(CashGamesGroupedUpdateDocument, options);
}
export type CashGamesGroupedUpdateSubscriptionHookResult = ReturnType<
  typeof useCashGamesGroupedUpdateSubscription
>;
export type CashGamesGroupedUpdateSubscriptionResult =
  Apollo.SubscriptionResult<Types.CashGamesGroupedUpdateSubscription>;
export const CashGamesGroupedDocument = gql`
  query cashGamesGrouped($include: Filter, $exclude: Filter) {
    cashGamesGrouped(include: $include, exclude: $exclude) {
      ...CommonSimpleGame
    }
  }
  ${CommonSimpleGameFragmentDoc}
`;

/**
 * __useCashGamesGroupedQuery__
 *
 * To run a query within a React component, call `useCashGamesGroupedQuery` and pass it any options that fit your needs.
 * When your component renders, `useCashGamesGroupedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCashGamesGroupedQuery({
 *   variables: {
 *      include: // value for 'include'
 *      exclude: // value for 'exclude'
 *   },
 * });
 */
export function useCashGamesGroupedQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.CashGamesGroupedQuery,
    Types.CashGamesGroupedQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.CashGamesGroupedQuery, Types.CashGamesGroupedQueryVariables>(
    CashGamesGroupedDocument,
    options
  );
}
export function useCashGamesGroupedLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.CashGamesGroupedQuery,
    Types.CashGamesGroupedQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.CashGamesGroupedQuery, Types.CashGamesGroupedQueryVariables>(
    CashGamesGroupedDocument,
    options
  );
}
export type CashGamesGroupedQueryHookResult = ReturnType<typeof useCashGamesGroupedQuery>;
export type CashGamesGroupedLazyQueryHookResult = ReturnType<typeof useCashGamesGroupedLazyQuery>;
export type CashGamesGroupedQueryResult = Apollo.QueryResult<
  Types.CashGamesGroupedQuery,
  Types.CashGamesGroupedQueryVariables
>;
